import { createFeatureSelector, createSelector } from '@ngrx/store';
import {AuthState, TokenState} from "./auth.state";

export const selectAuthState = createFeatureSelector<AuthState>('userAuthentication');
export const selectTokenState = createFeatureSelector<TokenState>('userToken');

export const selectUserAuthentication = createSelector(
    selectAuthState,
    (state) => state.authentication
);

export const selectUserAccountId = createSelector(
    selectUserAuthentication,
    (authentication) => authentication?.userAccountId ?? null
);

export const selectSchoolAccountId = createSelector(
    selectUserAuthentication,
    (authentication) => authentication?.schoolAccountId ?? null
);

export const selectAccountIds = createSelector(
    selectUserAccountId,
    selectSchoolAccountId,
    (userAccountId, schoolAccountId) => ({ userAccountId, schoolAccountId })
);

export const selectUserToken = createSelector(
    selectTokenState,
    (state) => state.token
);

export const selectUserAuthenticationLoading = createSelector(
    selectAuthState,
    (state) => state.loading
);

export const selectUserAuthenticationError = createSelector(
    selectAuthState,
    (state) => state.error
);

export const selectIsHydrated = createSelector(
    selectAuthState,
    (state) => state.isHydrated
);

export const selectUserTokenLoading = createSelector(
    selectTokenState,
    (state) => state.loading
);

export const selectUserTokenError = createSelector(
    selectTokenState,
    (state) => state.error
);